import React from "react";
import FieldRow from "../FieldRow";

export default function ProductResultCard({ item, isExpanded, onCopy }) {
  return (
    <>
      <div style={{ display: "grid", gap: "0.25rem", marginTop: "0.4rem" }}>
        <FieldRow label="ID" value={item.id} onCopy={onCopy} />
        <FieldRow label="Название" value={item.product_name} onCopy={onCopy} />
        <FieldRow label="Номер товара" value={item.product_number} onCopy={onCopy} />
        <FieldRow label="Количество (факт)" value={item.actual_quantity} onCopy={onCopy} />
        <FieldRow label="GTIN" value={item.gtin} onCopy={onCopy} />
        <FieldRow label="ID квитанции" value={item.receiptId} onCopy={onCopy} />
      </div>

      {isExpanded && Array.isArray(item.marks) && item.marks.length > 0 && (
        <div
          style={{
            marginTop: "0.6rem",
            borderTop: "1px solid #e2e8f0",
            paddingTop: "0.5rem",
          }}
        >
          <span
            style={{
              fontSize: "0.75rem",
              color: "#94a3b8",
              display: "block",
              marginBottom: "0.15rem",
            }}
          >
            Маркировки:
          </span>
          <div style={{ display: "flex", flexWrap: "wrap", gap: "0.25rem" }}>
            {item.marks.map((m, idx) => (
              <span
                key={idx}
                onClick={() => onCopy(m)}
                style={{
                  fontSize: "0.7rem",
                  borderRadius: "999px",
                  border: "1px solid #cbd5f5",
                  padding: "0.1rem 0.4rem",
                  cursor: "pointer",
                  background: "#e0ebff",
                }}
              >
                {m}
              </span>
            ))}
          </div>
        </div>
      )}
    </>
  );
}
